import { useMemo } from 'react';
import { routes } from '@dap/common/consts';
import {
  // useBrand,
  useUser,
} from '@dap/common/data-access';
import { NavRoute, NavWithSubRoutes } from '@shared/components';
import { SanityIcon, AdministrationIcon } from '@shared/custom-icons';
import { useLocation, matchPath } from 'react-router';
import { useAppTFunction } from '@dap/common/i18n';
import { useBrandDetails } from '@dap/common/data-access';
import { hasMemberadminAccess } from '@dap/memberadmin/utils';
// import { useBrandTFunction, useMemberadminTFunction } from '@dap/memberadmin/i18n';
// import { capitalizeFirstLetter } from '@shared/utils';

/**
 * Verifies that a user has access to brandadmin for a given brand and returns the relevant navigation routes
 *
 * If the user has access to one dataowner, the routes will be direct to the pages: info, locations, employees
 * If the user has access to 1 to 5 dataowners, the routes will be to a list of each dataowner
 * If the user has access to more than 5 dataowners, the routes will be to a list of all dataowners
 *
 * @returns
 */
export const useMemberadminRoute = (): NavRoute | undefined => {
  const { pathname } = useLocation();
  // const brand = useBrand();
  const t = useAppTFunction();
  // const tMemberadmin = useMemberadminTFunction();
  const { locations, dataownersForUser } = useBrandDetails();
  const userData = useUser();
  // const tBrand = useBrandTFunction(brand.key);

  // Get if user has member admin access for the current brand
  const hasMemberadminAccessForBrand = useMemo(() => {
    return hasMemberadminAccess(userData, locations, dataownersForUser);
  }, [userData, locations, dataownersForUser]);

  // const sortedDataownersForUser = useMemo(() => {
  //   return dataownersForUser.sort((a, b) => a.name.localeCompare(b.name));
  // }, [dataownersForUser]);

  if (!hasMemberadminAccessForBrand || dataownersForUser.length === 0) {
    return undefined;
  }

  // Build a list of all routes
  // const memberadminRoutes: NavRoute[] = [];

  const isMemberadminPath = matchPath(`${routes.memberadmin}/*`, pathname);
  // const isMemberadminPage = matchPath(routes.memberadmin, pathname);

  // memberadminRoutes.push({
  //   title: tMemberadmin('memberadmin.breadcrumb.home'),
  //   Icon: SanityIcon,
  //   isActive: !!isMemberadminPage,
  //   to: routes.memberadmin,
  // });

  /*
  if (sortedDataownersForUser.length === 1) {
    // If user has access to one dataowner, create NavRoutes directly to the pages: info, locations, employees, properties
    memberadminRoutes.push({
      title: tMemberadmin('memberadmin.info.title'),
      Icon: SanityIcon,
      isActive: !!matchPath(
        `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.info}/*`,
        pathname
      ),
      to: `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.info}`,
    });
    memberadminRoutes.push({
      title: tBrand('brand.location.name.plural', 'capitalize'),
      Icon: SanityIcon,
      isActive: !!matchPath(
        `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.locations}/*`,
        pathname
      ),
      to: `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.locations}`,
    });
    memberadminRoutes.push({
      title: capitalizeFirstLetter(t('employee.title.plural')),
      Icon: SanityIcon,
      isActive: !!matchPath(
        `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.employees}`,
        pathname
      ),
      to: `${routes.memberadmin}/${routes.member}/${sortedDataownersForUser[0].key}/${routes.employees}`,
    });
  } else if (sortedDataownersForUser.length > 1 && sortedDataownersForUser.length < 6) {
    // User has access 5 or less dataowners, add a NavRoute to each dataowner
    sortedDataownersForUser.forEach((dataowner) => {
      memberadminRoutes.push({
        title: dataowner.name,
        Icon: SanityIcon,
        isActive: !!matchPath(
          `${routes.memberadmin}/${routes.member}/${dataowner.key}/*`,
          pathname
        ),
        to: `${routes.memberadmin}/${routes.member}/${dataowner.key}`,
      });
    });
  } else {
    // User has access to more than 5 dataowners, add a route to a list of all dataowners
    memberadminRoutes.push({
      title: tBrand('brand.dataowner.name.plural', 'capitalize'),
      Icon: SanityIcon,
      isActive: !!matchPath(`${routes.memberadmin}/${routes.member}`, pathname),
      to: `${routes.memberadmin}/${routes.member}`,
    });
  }

  const hasActiveSubRoutes = memberadminRoutes.some((route) => route.isActive);
  */

  // const isActive = hasActiveSubRoutes || !!isMemberadminPath;
  const isActive = !!isMemberadminPath;

  // Return a NavWithSubRoutes object with the defines routes as subroutes
  return {
    title: t('common.navigation.memberadmin'),
    Icon: AdministrationIcon,
    isActive: isActive,
    to: routes.memberadmin,
    // initialOpen: isActive,
    // subRoutes: memberadminRoutes.map((route) => ({
    //   title: route.title,
    //   Icon: SanityIcon,
    //   isActive: route.isActive,
    //   to: route.to,
    //   external: route.external,
    //   href: route.href,
    // })),
  };
};
